var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c(
        "a-row",
        [
          _c("a-col", { attrs: { span: "2" } }),
          _c(
            "a-col",
            { attrs: { span: "22" } },
            [
              _c(
                "a-space",
                [
                  _c(
                    "a-form-model",
                    {
                      ref: "searchForm",
                      attrs: { layout: "inline", model: _vm.formState },
                    },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "所属市县", prop: "region" } },
                        [
                          _c("a-ext-dist-picker", {
                            model: {
                              value: _vm.formState.region,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "region", $$v)
                              },
                              expression: "formState.region",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "检测机构", prop: "execDept" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "200px",
                              },
                            },
                            [
                              _c("a-ext-gov-ji-lian", {
                                model: {
                                  value: _vm.formState.execDept,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "execDept", $$v)
                                  },
                                  expression: "formState.execDept",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "a-form-model-item",
                        [
                          _c(
                            "a-space",
                            [
                              _c(
                                "a-button",
                                { on: { click: _vm.onResetSearch } },
                                [_vm._v("重置")]
                              ),
                              _c("a-divider", {
                                attrs: { dashed: "true", type: "vertical" },
                              }),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.addItem },
                                },
                                [_vm._v("确认")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "big-title" }, [
        _c("span", [
          _vm._v(
            "需分任务数" +
              _vm._s(_vm.needCheckCount) +
              " 已分配任务数" +
              _vm._s(_vm.checkedCount)
          ),
        ]),
      ]),
      _c(
        "a-row",
        [
          _c(
            "a-row",
            { attrs: { gutter: 4 } },
            [
              _c("a-col", { attrs: { span: 2 } }),
              _c("a-col", { attrs: { span: 2 } }, [
                _c("span", { staticClass: "list-header" }, [_vm._v("序列")]),
              ]),
              _c("a-col", { attrs: { span: 10 } }, [
                _c("span", { staticClass: "list-header" }, [
                  _vm._v("检测机构名称"),
                ]),
              ]),
              _c("a-col", { attrs: { span: 6 } }, [
                _c("span", { staticClass: "list-header" }, [_vm._v("检测数")]),
              ]),
              _c("a-col", { attrs: { span: 4 } }),
            ],
            1
          ),
          _vm._l(_vm.localValue, function (task, index) {
            return _c(
              "a-row",
              { style: { margin: "4px" }, attrs: { gutter: 4 } },
              [
                _c("a-col", { attrs: { span: 2 } }),
                _c("a-col", { attrs: { span: 2 } }, [
                  _c("span", { staticClass: "list-header" }, [
                    _vm._v(_vm._s(index + 1)),
                  ]),
                ]),
                _c("a-col", { attrs: { span: 10 } }, [
                  _c("span", { staticClass: "list-header" }, [
                    _vm._v(_vm._s(task.execDept)),
                  ]),
                ]),
                _c(
                  "a-col",
                  { attrs: { span: 6 } },
                  [
                    _c("a-input-number", {
                      attrs: { min: 1, max: _vm.needCheckCount },
                      on: { change: _vm.changeNum },
                      model: {
                        value: task.checkCount,
                        callback: function ($$v) {
                          _vm.$set(task, "checkCount", $$v)
                        },
                        expression: "task.checkCount",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    index
                      ? _c(
                          "a-button",
                          {
                            attrs: { type: "link" },
                            on: {
                              click: function ($event) {
                                return _vm.removeItem(task)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "big-title" }, [
      _c("span", [_vm._v("地区及机构")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }